import { api } from "./http-client";
import { PhoneRegion, PhoneRegionFormValues } from "../types/phone-region";

export const phoneRegionsService = {
  list: async (): Promise<PhoneRegion[]> => {
    const res = await api.request<PhoneRegion[]>({
      url: "/admin/phone-regions",
      method: "GET",
    });
    return res.data;
  },

  create: async (data: PhoneRegionFormValues): Promise<PhoneRegion> => {
    const res = await api.request<PhoneRegion>({
      url: "/admin/phone-regions",
      method: "POST",
      data,
    });
    return res.data;
  },

  update: async (
    id: string,
    data: Partial<PhoneRegionFormValues>,
  ): Promise<PhoneRegion> => {
    const res = await api.request<PhoneRegion>({
      url: `/admin/phone-regions/${id}`,
      method: "PUT",
      data,
    });
    return res.data;
  },

  remove: async (id: string): Promise<void> => {
    await api.request({ url: `/admin/phone-regions/${id}`, method: "DELETE" });
  },

  reorder: async (items: Array<{ id: string; sortOrder: number }>): Promise<void> => {
    await api.request({
      url: "/admin/phone-regions/reorder",
      method: "PUT",
      data: { items },
    });
  },
};
